export default __webpack_public_path__ + "static/media/ic-home.a8921e7a.svg";